import axios from '../axios/axios-auth'

export default class DevicesService {

    save(data) {
        return axios.post('/api/v1/devices', data).then(response => response.data)
    }

    getDeviceByVehicle(chassis) {
        return axios.get('/api/v1/devices/vehicle/' + chassis).then(response => response.data);
    }

    getDevicesByOrg(orgId) {
        return axios.get(`/api/v3/organizations/${orgId}/devices`).then(response => response.data);
    }

    transferDevice(deviceId, orgId, transferVehicle) {
        return axios.patch(`/api/v3/devices/${deviceId}/transfer`, null, {
            params: {orgId: orgId, transferVehicle: transferVehicle}
        }).then(response => response.data);
    }
}
